import React, { useEffect } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LinkIcon from "@mui/icons-material/Link";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Button } from "react-bootstrap";

const ModalShare = ({ isOpen, onClose, urlBlog, noticia }) => {
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "630905682261052",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v13.0",
      });
    };
  }, []);

  /* Share */

  const facebook = () => {
    window.FB.ui(
      {
        display: "popup",
        method: "share",
        href: window.location.href,
      },
      function (response) {
        console.log(response);
      }
    );
  };

  function crearOActualizarMetaTag(propiedad, contenido, name) {
    let metaTagExistente;

    if ((name && !propiedad) || propiedad === "_") {
      metaTagExistente = document.querySelector(`meta[name="${name}"]`);
    } else {
      metaTagExistente = document.querySelector(
        `meta[property="${propiedad}"]`
      );
    }
    if (metaTagExistente) {
      metaTagExistente.setAttribute("content", contenido);
    } else {
      const metaTag = document.createElement("meta");
      if (propiedad !== "_") {
        metaTag.setAttribute("property", propiedad);
      } else {
        metaTag.setAttribute("name", name);
      }
      metaTag.setAttribute("content", contenido);
      document.head.appendChild(metaTag);
    }
  }

  const baseUrl = "https://tensolite.com";

  const urlSinPuntos = urlBlog.split(".")[0];
  const urlArticlePost = `${baseUrl}/nueva-noticias/${urlSinPuntos}`;

  useEffect(() => {
    const imageBaseUrl = "https://tensocombetest.sitenso.link";
    const imageUrl =
      noticia?.imageCover && noticia?.imageCover[0]?.url
        ? noticia.imageCover[0].url
        : noticia.video;
    const imageUrlSinLocalhost = imageUrl?.startsWith("http://localhost:9001")
      ? imageUrl.replace("http://localhost:9001", imageBaseUrl)
      : imageUrl;

    const title = noticia?.title;
    const description = noticia?.titleBody;

    crearOActualizarMetaTag("_", title, "title");
    crearOActualizarMetaTag("_", description, "description");
    crearOActualizarMetaTag("twitter:card", "summary_large_image");
    crearOActualizarMetaTag("twitter:site", "@tensolite");
    crearOActualizarMetaTag("twitter:creator", "@tensolite");
    crearOActualizarMetaTag("twitter:title", title);
    crearOActualizarMetaTag("twitter:description", description);
    crearOActualizarMetaTag("twitter:image", imageUrlSinLocalhost);
    crearOActualizarMetaTag("twitter:url", urlArticlePost);
    crearOActualizarMetaTag("og:title", title, "title");
    crearOActualizarMetaTag("og:description", description, "description");
    crearOActualizarMetaTag("og:image", imageUrlSinLocalhost, "image");
    crearOActualizarMetaTag("og:url", urlArticlePost);
    crearOActualizarMetaTag("og:image:width", "1280");
    crearOActualizarMetaTag("og:image:height", "640");
    document.title = title;
  }, [
    baseUrl,
    noticia?.title,
    noticia?.titleBody,
    noticia.imageCover,
    urlArticlePost,
    noticia.video,
  ]);

  const handleWhatsAppShare = () => {
    const urlArticlePostEncoded = encodeURIComponent(urlArticlePost);
    const whatsappUrl = `https://api.whatsapp.com/send?text=${urlArticlePostEncoded}`;
    window.open(whatsappUrl, "_blank");
  };

  function shareTwitter(url, text) {
    console.log(url);
    window.open(` https://twitter.com/intent/tweet?url=${url}&text=${text}`);
  }

  function shareLinkedIn(url, text, description) {
    window.open(
      `https://www.linkedin.com/shareArticle?url=${url}`
    );
  }

  return (
    <>
      {isOpen && (
        <section className={`modal-container-redes ${isOpen && "modal-open"} `}>
          <section className="modal-shared-container">
            <div className="modal-content-container">
              <h3>Comparte nuestra historia en:</h3>
              <div className="modal-separator"></div>
              <h4>Comparte via!</h4>
              <div className="container-redes">
                <button onClick={facebook}>
                  <FacebookIcon sx={{ color: "white" }} />
                </button>
                <button
                  onClick={() =>
                    shareLinkedIn(
                      urlArticlePost,
                      noticia.titleBody,
                      noticia.titleBody
                    )
                  }
                >
                  <LinkedInIcon sx={{ color: "white" }} />
                </button>
                <button
                  onClick={() =>
                    shareTwitter(urlArticlePost, noticia.titleBody)
                  }
                >
                  <TwitterIcon sx={{ color: "white" }} />
                </button>
                <button onClick={handleWhatsAppShare}>
                  <WhatsAppIcon sx={{ color: "white" }} />
                </button>
              </div>
              <span>O copia nuestro Link!</span>
              <div className="container-link-copy">
                <div className="link">
                  <LinkIcon />
                  <span>Link.com/ejemplo/linkPrueba.com</span>
                </div>
                <button>Copiar!</button>
              </div>
              <Button
                variant="ghost"
                size="lg"
                onClick={onClose}
                className="btn-close-share-redes"
              >
                x
              </Button>
            </div>
          </section>
        </section>
      )}
    </>
  );
};

export default ModalShare;
